var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10C18 14.4183 14.4183 18 10 18C5.58171 18 2 14.4183 2 10C2 5.58171 5.58171 2 10 2C14.4183 2 18 5.58171 18 10ZM10.404 13.8326C10.5111 13.7254 10.5713 13.5801 10.5713 13.4286C10.5713 13.2771 10.5111 13.1317 10.404 13.0246L7.95086 10.5714H13.4286C13.5801 10.5714 13.7255 10.5112 13.8326 10.4041C13.9398 10.2969 14 10.1516 14 10C14 9.84845 13.9398 9.7031 13.8326 9.59594C13.7255 9.48878 13.5801 9.42857 13.4286 9.42857H7.95086L10.404 6.97543C10.5081 6.86766 10.5657 6.72331 10.5644 6.57349C10.5631 6.42366 10.503 6.28034 10.397 6.17439C10.2911 6.06844 10.1478 6.00835 9.99794 6.00704C9.84812 6.00574 9.70377 6.06334 9.596 6.16743L6.16743 9.596C6.0603 9.70316 6.00012 9.84848 6.00012 10C6.00012 10.1515 6.0603 10.2968 6.16743 10.404L9.596 13.8326C9.70316 13.9397 9.84848 13.9999 10 13.9999C10.1515 13.9999 10.2968 13.9397 10.404 13.8326Z",
    fill: "#407DBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftCircle);
export default __webpack_public_path__ + "static/media/arrow-left-circle.edd60ec24106b0bfc61fce2ca7383c5b.svg";
export { ForwardRef as ReactComponent };